import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context2; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context2 = Object.prototype.toString.call(o)).call(_context2, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.object.to-string.js";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import 'core-js/es/array/find';
import React, { useState, useImperativeHandle, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { usePopper } from 'react-popper';
import maxSizeModifier from 'popper-max-size-modifier';
import { useLayeringContext, useTheme, LayeringProvider, ThemeProvider, getInverseTheme } from '@rescui/ui-contexts';
import FocusLock from 'react-focus-lock';
import ReactDOM from 'react-dom';
import { useDropdownState, DROPDOWN_STATES } from './use-dropdown-state.js';
import { useScrollableContainer } from './use-scrollable-container.js';
import styles from './index.p.module.css.js';
import { applyMaxSize, sameWidthModifier } from './custom-modifiers.js'; // fix popper-js for IE11

function getPopperOptions(_ref) {
  var placement = _ref.placement,
      maxHeight = _ref.maxHeight,
      leastMaxHeight = _ref.leastMaxHeight,
      maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth;
  return {
    placement: placement,
    modifiers: [{
      name: 'hide',
      enabled: false
    }, {
      name: 'flip',
      enabled: true
    }, {
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, 8]
      }
    }, maxSizeModifier, _objectSpread(_objectSpread({}, applyMaxSize), {}, {
      options: {
        maxHeight: maxHeight,
        leastMaxHeight: leastMaxHeight
      }
    }), _objectSpread(_objectSpread({}, sameWidthModifier), {}, {
      options: {
        maxWidth: maxWidth,
        minWidth: minWidth
      }
    })]
  };
}

var Portal = function Portal(_ref2) {
  var children = _ref2.children,
      _ref2$target = _ref2.target,
      target = _ref2$target === void 0 ? document.body : _ref2$target;
  return /*#__PURE__*/ReactDOM.createPortal(children, target);
};

function useOnOutsideClick(_ref3) {
  var _context;

  var onOutsideClick = _ref3.onOutsideClick,
      isEnabled = _ref3.isEnabled,
      _ref3$ignoreElements = _ref3.ignoreElements,
      ignoreElements = _ref3$ignoreElements === void 0 ? [] : _ref3$ignoreElements;
  var ignoreElementRefsExists = ignoreElements.length > 0 && ignoreElements.every(Boolean);
  var handleDocumentClick = useCallback(function (e) {
    var _iterator = _createForOfIteratorHelper(ignoreElements),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var element = _step.value;

        if (!element || e.target === element || element.contains(e.target)) {
          return;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    onOutsideClick();
  }, _concatInstanceProperty(_context = [onOutsideClick]).call(_context, _toConsumableArray(ignoreElements))); // eslint-disable-next-line consistent-return

  useEffect(function () {
    if (isEnabled && ignoreElementRefsExists) {
      document.addEventListener('click', handleDocumentClick, true);
      return function () {
        return document.removeEventListener('click', handleDocumentClick, true);
      };
    }
  }, [handleDocumentClick, isEnabled, ignoreElementRefsExists]);
}

function useKeyPress(_ref4) {
  var key = _ref4.key,
      onKeyPress = _ref4.onKeyPress,
      isEnabled = _ref4.isEnabled;
  useEffect(function () {
    if (!isEnabled) {
      return;
    }

    var keyDownHandler = function keyDownHandler(e) {
      if (e.key === key) {
        e.preventDefault();
        onKeyPress();
      }
    };

    document.addEventListener('keydown', keyDownHandler, true); // eslint-disable-next-line consistent-return

    return function () {
      document.removeEventListener('keydown', keyDownHandler, true);
    };
  }, [key, onKeyPress, isEnabled]);
}

var DropdownRender = function DropdownRender(_ref5, externalRef) {
  var children = _ref5.children,
      trigger = _ref5.trigger,
      themeFromProps = _ref5.theme,
      _ref5$isOpen = _ref5.isOpen,
      isOpen = _ref5$isOpen === void 0 ? false : _ref5$isOpen,
      _ref5$placement = _ref5.placement,
      placement = _ref5$placement === void 0 ? 'bottom-start' : _ref5$placement,
      _ref5$mode = _ref5.mode,
      mode = _ref5$mode === void 0 ? 'classic' : _ref5$mode,
      _ref5$onRequestClose = _ref5.onRequestClose,
      onRequestClose = _ref5$onRequestClose === void 0 ? function () {} : _ref5$onRequestClose,
      minWidth = _ref5.minWidth,
      maxWidth = _ref5.maxWidth,
      maxHeight = _ref5.maxHeight,
      leastMaxHeight = _ref5.leastMaxHeight,
      _ref5$cancelCloseAnim = _ref5.cancelCloseAnimation,
      cancelCloseAnimation = _ref5$cancelCloseAnim === void 0 ? false : _ref5$cancelCloseAnim,
      className = _ref5.className,
      _ref5$closeOnEsc = _ref5.closeOnEsc,
      closeOnEsc = _ref5$closeOnEsc === void 0 ? true : _ref5$closeOnEsc,
      _ref5$closeOnTab = _ref5.closeOnTab,
      closeOnTab = _ref5$closeOnTab === void 0 ? false : _ref5$closeOnTab,
      _ref5$disableFocusLoc = _ref5.disableFocusLock,
      disableFocusLock = _ref5$disableFocusLoc === void 0 ? false : _ref5$disableFocusLoc,
      _ref5$renderInTrigger = _ref5.renderInTrigger,
      renderInTrigger = _ref5$renderInTrigger === void 0 ? false : _ref5$renderInTrigger;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      popperRef = _useState2[0],
      setPopperRef = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      triggerRef = _useState4[0],
      setTriggerRef = _useState4[1];

  var _useScrollableContain = useScrollableContainer(),
      setContentEl = _useScrollableContain.setContentEl,
      scrollableStyles = _useScrollableContain.scrollableStyles;

  useOnOutsideClick({
    isEnabled: isOpen,
    onOutsideClick: onRequestClose,
    ignoreElements: [popperRef, triggerRef]
  });
  useKeyPress({
    key: 'Escape',
    isEnabled: isOpen && closeOnEsc,
    onKeyPress: onRequestClose
  });
  useKeyPress({
    key: 'Tab',
    isEnabled: isOpen && closeOnTab,
    onKeyPress: onRequestClose
  });

  var _useDropdownState = useDropdownState(isOpen, cancelCloseAnimation),
      _useDropdownState2 = _slicedToArray(_useDropdownState, 2),
      handleAnimationEnd = _useDropdownState2[0],
      dropdownState = _useDropdownState2[1];

  var _usePopper = usePopper(triggerRef, popperRef, getPopperOptions({
    placement: placement,
    maxHeight: maxHeight,
    leastMaxHeight: leastMaxHeight,
    minWidth: minWidth,
    maxWidth: maxWidth
  })),
      popperStyles = _usePopper.styles,
      attributes = _usePopper.attributes,
      update = _usePopper.update;

  useImperativeHandle(externalRef, function () {
    return {
      scheduleUpdate: function scheduleUpdate() {
        if (update) {
          update();
        }
      }
    };
  });

  var _useLayeringContext = useLayeringContext(),
      dropdownZIndex = _useLayeringContext.dropdownZIndex;

  var theme = useTheme(themeFromProps);
  var triggerRenderer = typeof trigger === 'function' ? trigger({
    ref: setTriggerRef
  }) : /*#__PURE__*/React.createElement("span", {
    "data-test": "dropdown-trigger",
    className: styles.triggerWrapper,
    ref: setTriggerRef
  }, trigger);
  var dropdownShouldBeRendered = dropdownState !== DROPDOWN_STATES.CLOSE;
  var wrapperShouldBeHidden = dropdownState === DROPDOWN_STATES.CLOSING;
  return /*#__PURE__*/React.createElement(React.Fragment, null, triggerRenderer, dropdownShouldBeRendered && /*#__PURE__*/React.createElement(Portal, {
    target: renderInTrigger ? triggerRef : undefined
  }, /*#__PURE__*/React.createElement("div", _objectSpread({
    ref: setPopperRef,
    style: _objectSpread(_objectSpread({
      maxHeight: maxHeight
    }, popperStyles.popper), {}, {
      zIndex: dropdownZIndex
    }),
    className: cn(styles.dropdown, className, mode === 'rock' && styles.modeRock, theme === 'dark' ? styles.themeDark : styles.themeLight),
    "data-test": "dropdown"
  }, attributes.popper), /*#__PURE__*/React.createElement(LayeringProvider, {
    baseLayer: 'dropdown'
  }, /*#__PURE__*/React.createElement("div", {
    style: scrollableStyles,
    className: cn(styles.contentWrapper, wrapperShouldBeHidden && styles.wrapperHidden),
    onTransitionEnd: handleAnimationEnd,
    onAnimationEnd: handleAnimationEnd,
    "data-test": "dropdown-content"
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: mode === 'rock' ? getInverseTheme(theme) : theme
  }, /*#__PURE__*/React.createElement(FocusLock, {
    ref: setContentEl,
    disabled: dropdownState !== DROPDOWN_STATES.OPEN || disableFocusLock,
    returnFocus: {
      preventScroll: true
    },
    focusOptions: {
      preventScroll: true
    }
  }, children)))))));
};
/* eslint-enable react/prop-types */


var Dropdown = /*#__PURE__*/React.forwardRef(DropdownRender);
Dropdown.propTypes = {
  trigger: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func,
  theme: PropTypes.oneOf(['light', 'dark']),
  mode: PropTypes.oneOf(['classic', 'rock']),
  placement: PropTypes.oneOf(['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start']),
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxHeight: PropTypes.number,
  leastMaxHeight: PropTypes.number
};
export { Dropdown, Dropdown as default };
